import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useFaqs = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['faqs'],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/faqs`});
      return result;
    },
    staleTime: 0, 
    cacheTime: 0
  });
};
